export default "__VITE_ASSET__DWnhAYZu__"